<template>
	<div class="loader">
		<i class="fas fa-yin-yang fa-spin fa-4x"></i>
	</div>
</template>
